import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { push } from 'react-router-redux';
//Used to verify that the adress exists
//import { geocodeByAddress } from 'react-places-autocomplete';

import * as userActions from './../user/userActions'; 

import Aux from './../../hoc/_Aux';

//-- Utils
import { pushPageView } from '../../utils/tracking/customGtm';
import { pushHeaderTitle } from '../../utils/dom/helper';
import { generateInputControls, onChangedHandler, onChangedPlacesAutoCompleteHandler, generateForm } from './../../utils/form/generateFormTools';
import { validate } from './../../utils/form/validation';

class CreateUserForm extends Component {

    // defines inputs that belongs to the current form
    // Note : for using several element which have the same Type, they must be named as following
    // syntax : <element's type>_<element's name> 
    elementsForForm = {
        username:{
            title: 'Écris ton pseudo',
            labelPosition: 'left',
            label: 'Évite de donner ton vrai nom',
            placeholder: 'Pseudo',
            defaultValue: ''
        },
        password: {
            title: 'Écris ton mot de passe',
            labelPosition: 'left',
            label: 'Avec au minimum 6 caractères, 1 lettre et 1 chiffre',
            placeholder: 'Mot de passe',
            defaultValue: ''
        },
        password_confirm: {
            bloc: 'end',
            labelPosition: '',
            label: '',
            placeholder: 'Confirme Mot de Passe',
            defaultValue: '',
            validation: {
                required: [true, 'Hey ! Tu as oublié de confirmer ton mot de passe']
            }  
        },
        label_avatar:{
            title: 'Choisis ton personnage',
        },
        birthday:{
            //title: 'C\'est quand ta date de naissance ?',
            title: 'ta date de naissance?',
            labelPosition: 'left',
            label: 'On te préparera une surprise pour ton anniversaire',
            placeholder: 'JJ/MM/AAAA',
            defaultValue: ''
        },
        city:{
            title: 'Tu habites où?',
            labelPosition: 'left',
            label: 'C\'est pour préparer des événements rien que pour toi',
            defaultValue: '',
            valid: true, //valid by default 
        },
        email_parent:{
            //title: 'C\'est quoi le mail de tes parents ?',
            title: 'le mail de tes parents?',
            labelPosition: 'left',
            label: 'Ton parent doit renseigner son mail afin que tu puisses t\'inscrire',
            placeholder: 'Mail',
            defaultValue: '',
            validation: {
                required: [true, 'N\'oublie pas de renseigner le mail de tes parents'],
            } 
        },
        label_kids:{
            title: 'En tant que parent',
        },
        checkbox_kids:{
            labelPosition: 'right',
            label:'J\'autorise mon enfant à s\'inscrire à KidsMatin *',
            defaultValue: 0,
            validation: {
                isChecked: [true, 'Tes parents doivent accepter que tu t\'inscrives à Kids Matin'],
            }
        },
        checkbox_cgu:{
            labelPosition: 'right',
            label:'J\'ai pris connaissance des CGU et notamment de l\'autorisation de collecte de données *',
            options: {
                labelHandler: this.CGUClickHandler,
                labelHandlerOn: 'CGU',
                obj: this
            },
            defaultValue: 0,
            validation: {
                isChecked: [true, 'Tes parents doivent accepter les conditions générales d’utilisation'],
            }
        },
        checkbox_promo:{
            labelPosition: 'right',
            label:'J\'autorise la collecte de mes données à des fins commerciales',
            defaultValue: 0,
            valid: true, //valid by default 
            validation:{
            }
        },
        label_mention:{
            title: '* Mentions obligatoires',
        },
        submit: {
            defaultValue: 'C\'est parti !' //submit needs value instead of label
        }
    };

    formOrder = {
      block_left: 
        ['username',
         'password',
         'password_confirm'],
      block_middle:[
        'label_avatar','avatar'],
      block_right:['birthday',
        'city', 
        'email_parent'],
      block_bottom: ['label_kids','checkbox_kids','checkbox_cgu','checkbox_promo'],
      block_mention: 'label_mention',
      block_submit: 'submit'
    };

    state = {
        controls: generateInputControls(['username',
                                         'password',
                                         'password_confirm',
                                         'label_avatar','avatar',
                                         'birthday',
                                         'city', 
                                         'email_parent',
                                         'label_kids','checkbox_kids','checkbox_cgu','checkbox_promo', 'label_mention',
                                         'submit'], this.elementsForForm),
        formErrorMessage: '',                                 
    }

    inputChangedHandler = onChangedHandler;
    inputChangedPlacesAutoCompleteHandler = onChangedPlacesAutoCompleteHandler;

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Création du profile');

        //-- Push GTM page view
        pushPageView();

        //-- Add event listener for carousel
        window.addEventListener('resize', this.resize);
    }

    resize = () => this.forceUpdate()


    componentWillUnmount() {
        //-- Remove event listener for carousel
        window.removeEventListener('resize', this.resize)
    }

    CGUClickHandler () {
        this.props.displayCGU();
    }

    submitHandler = ( event ) => {
        event.preventDefault();
     
        /* Used to verify that the adress exists*/
        /*geocodeByAddress(this.state.controls.city.value)
            .then(result => console.log(result))
            .catch(error => console.error('Error', error));*/

        
        
        // check inputs values
        let FormIsValid = true;
        let errors = [];

        const updatedControls = {...this.state.controls};

        //We have to check the format of the birthday date in case the use use safari
        const initialDate = this.state.controls.birthday.value;
        const authorizedSafariFormatPattern = /^([0-9]{2})(-|\/)?([0-9]{2})(-|\/)?([0-9]{4})$/;
        const patternFound = this.state.controls.birthday.value.match(authorizedSafariFormatPattern);
        if(patternFound !== null)
        {
            this.state.controls.birthday.value = patternFound[5] + '-' + patternFound[3] + '-' + patternFound[1];
        }

        for (let controlName in this.state.controls) {
            const controlElement = this.state.controls[controlName];
            // if form element are invalid and there is no error message set on the field, we update controls accordingly    
            if(controlElement.valid===false){
                
                FormIsValid = false; 
                if(controlElement.errorMessage===''){
                    const validation = validate( controlElement.value, controlElement.validation ); 
                    if(!validation['isValid']){
                        FormIsValid = false;
                        errors.push([controlName, validation['errorMessage']]);
                        updatedControls[controlName] = {
                            ...this.state.controls[controlName],
                            //valid: validation['isValid'],
                            //errorMessage: validation['errorMessage'],
                            touched: true
                        };

                    }
                }
                else {
                    errors.push([controlName, controlElement.errorMessage]);
                }
            }
        }

        //Password validation
        const passwordErrorIndex = errors.findIndex((element) => { return element[0] === 'password' });
        const passwordConfirmErrorIndex = errors.findIndex((element) => { return element[0] === 'password_confirm' });

        //if we have an error on password we delete the error on passwor_confirm
        if( passwordErrorIndex !== -1 && passwordConfirmErrorIndex !== -1)
        {
            errors.splice(passwordConfirmErrorIndex, 1);
        }
        //if we don't have any error on password_confirm and the passwords are differents
        else if (passwordConfirmErrorIndex === -1 && this.state.controls.password.value !== this.state.controls.password_confirm.value)
        {
            FormIsValid = false;
            const usernameErrorIndex = errors.findIndex((element) => { return element[0] === 'username' });
            const arr = ['password', 'Tes mots de passe ne sont pas identiques :/'];
            errors.splice(usernameErrorIndex +1, 0, arr);
        }

        if(FormIsValid){
            this.props.onCreate( this.state.controls.username.value, 
                                 this.state.controls.password.value, 
                                 this.state.controls.password_confirm.value,
                                 this.state.controls.avatar.value,
                                 this.state.controls.birthday.value,
                                 this.state.controls.city.value,
                                 this.state.controls.email_parent.value,
                                 this.state.controls.checkbox_promo.value
                                );
        }
        else {
            updatedControls.birthday.value = initialDate; //we revert the date to its original value for safari browsers
            this.setState( { controls: updatedControls, formErrorMessage:'Les champs suivants ne respectent pas le format attendu' } );
            this.props.onError(errors);
        }
   
        return FormIsValid;                   
    }

    render(){
        let form = generateForm(this, this.state.controls, this.formOrder);

        return (
            <Aux>
                <form onSubmit={this.submitHandler} name={this.props.name}>
                    {form}
                </form>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        hasError: state.user.hasError,
        errorMessage: state.user.errorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreate: ( username, password, password_confirm, avatar, birthday, city, email_parent, optin_commercial ) => dispatch( 
            userActions.createUser(username, password, password_confirm, avatar, birthday, city, email_parent, optin_commercial) 
        ),
        onError: (errors) => dispatch(userActions.createUserErrors(errors))

    };
};

export default connect( mapStateToProps, mapDispatchToProps )(CreateUserForm);


// WEBPACK FOOTER //
// ./src/components/forms/createUserForm.js